import * as React from "react";

import { Box, SwipeableDrawer } from "@material-ui/core";
import { MenuOutlined } from "@material-ui/icons";
import { drawerBleeding } from "../..";
import { ListItemStyled, Root, StyledBox } from "./styles";
import { useNavigate } from "react-router";
import { logoutHelper } from "../../utils";

function SideDrawer(props) {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const logUserOut = () => {
    logoutHelper(navigate);
  };

  const navigateTo = (page) => {
    setOpen(false);
    navigate(page);
  };

  return (
    <Root>
      <Box
        sx={{
          textAlign: "center",
          pt: 1,
          position: "absolute",
          left: 10,
          top: 11,
          zIndex: 10000,
          cursor: "pointer",
        }}
      >
        {/* <TitleBar /> */}
        <MenuOutlined style={{ color: "#fff" }} onClick={toggleDrawer(true)} />
      </Box>
      {open ? (
        <SwipeableDrawer
          // container={container}
          anchor="bottom"
          open={open}
          onClose={toggleDrawer(false)}
          onOpen={toggleDrawer(true)}
          swipeAreaWidth={drawerBleeding}
          disableSwipeToOpen={false}
          ModalProps={{
            keepMounted: true,
          }}
        >
          <StyledBox
            sx={{
              px: 2,
              pb: 2,
              height: "100%",
              overflow: "auto",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                px: 2,
                pb: 2,
                display: "flex",
              }}
            >
              <ListItemStyled onClick={() => navigateTo("/")}>
                Home
              </ListItemStyled>
              <ListItemStyled onClick={() => navigateTo("/users")}>
                Users
              </ListItemStyled>
              <ListItemStyled onClick={() => navigateTo("/privacy-policy")}>
                Privacy Policy
              </ListItemStyled>
              <ListItemStyled onClick={() => navigateTo("/release-notes")}>
                Releases
              </ListItemStyled>
              <ListItemStyled onClick={logUserOut}>Logout</ListItemStyled>
            </div>
          </StyledBox>
        </SwipeableDrawer>
      ) : null}
    </Root>
  );
}

export default SideDrawer;
